// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Footer_wrapper__2uIdw","text":"Footer_text__1NaOG","name":"Footer_name__3yZg4","box":"Footer_box__rKsj7"};